import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import { library, dom, config } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Ajax from '@lib/ajax'

import BootstrapVue from 'bootstrap-vue'
import VueMq from 'vue-mq' // https://www.npmjs.com/package/vue-mq
import VueSwal from 'vue-swal' // https://github.com/anteriovieira/vue-swal
import Toasted from 'vue-toasted' // https://github.com/shakee93/vue-toasted
import VeeValidate, { Validator } from 'vee-validate'; // https://baianat.github.io/vee-validate
import FlatPickr from "flatpickr";
import VueFlatPickr from 'vue-flatpickr-component'; // https://github.com/ankurk91/vue-flatpickr-component


import 'flatpickr/dist/flatpickr.css';
  
import { Czech as CzechFlatPickrLocale } from 'flatpickr/dist/l10n/cs.js';
import CzechVeeValidateLocale from 'vee-validate/dist/locale/cs';
import AbpBase from '@src/mixins/abpbase.js'
import Utils from '@lib/util'
import AppConfigService from '@src/services/config'

library.add(fas)

// config.autoReplaceSvg = true
// config.observeMutations = true // <- this is what you need the most

// dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver

Vue.component('font-awesome-icon', FontAwesomeIcon)


// 3rd components configuration

FlatPickr.setDefaults({
  wrap: false, // set wrap to true only when using 'input-group'
  altFormat: 'd.m.Y',
  altInput: true
})
FlatPickr.localize(CzechFlatPickrLocale);
Validator.localize('cs', CzechVeeValidateLocale);


// Registering custom Mixins
Vue.mixin(AbpBase);

// Registering 3rd components as plugin

Vue.use(VueFlatPickr);
Vue.use(VeeValidate, { inject: true, fieldsBagName: 'veeFields', locale: 'cs', events: 'input|change|blur|on-close' }); 
Vue.use(Toasted)
Vue.use(VueSwal)
Vue.use(BootstrapVue)
Vue.use(VueMq, {
  breakpoints: {
    sm: 576,
    md: 768,
    lg: 992,
    bg: 1200,
  },
})



// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}


AppConfigService.loadAppConfigAsync().then(config => {

  // Set axios BASE URL before application mount
  Ajax.defaults.baseURL = config.apiBaseUrl;

  Ajax.get("/AbpUserConfiguration/GetAll").then(response => {

      Utils.abp = Utils.extend(true, Utils.abp, response.data.result);
    
      const app = new Vue({
        router,
        store,
        render: (h) => h(App),
      }).$mount('#app')
      
      // If running inside Cypress...
      if (window.Cypress) {
        // Attach the app to the window, which can be useful
        // for manually setting state in Cypress commands
        // such as `cy.logIn()`.
        window.__app__ = app
      }
      
    })

});